// checkoutSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { createOrder, fetchCities, fetchCountries } from '../../services/checkoutService';

 interface cartItem {
    name: string;
    quantity: number;
    price: number
}
interface billingAddressState {
    email : string;
    firstName: string;
    lastName: string;
    company: string;
    streetAddress: string;
    phone: string;
    Country: string;
    city: string;
    postCode: string;
}
interface checkoutState {
    billingAddress : billingAddressState,
    extraNote: string,
    paymentMethod: 'paypal' | 'banktransfer',
    cart: any,
    taxe: number,
    shippingCost: number,
    discount: number,
    totalItems: number,
    loader: 'idel' | 'loading' | 'error' | 'success'
   //shippingAddress : billingAddressState
}
const initialStateCart = JSON.parse(localStorage.getItem('items'))
const initialState : checkoutState = {

    cart: initialStateCart,
    billingAddress : {
        email : "",
        firstName: "",
        lastName: "",
        company: "",
        streetAddress: "",
        phone: "",
        Country: "",
        city: "",
        postCode: "",
    },
    paymentMethod: 'paypal',
    extraNote: "",
    taxe: 0,
    shippingCost: 0,
    discount: 5,
    totalItems: initialStateCart.reduce((total, item) => total + (item.price * item.quantity), 0),
    loader : 'idel'
}

const checkoutSlice = createSlice({
    name: 'checkout',
    initialState,
    reducers: {
        // clearCart (state){
        //     state.cart = []
        //     localStorage.removeItem('items')
        // }
    },
    extraReducers : (builder) => {
        builder
        .addCase(createOrder.pending, (state) => {
            state.loader = 'loading'
        })
        .addCase(createOrder.rejected, (state, action) => {
            state.loader = 'error';
        })
        .addCase(createOrder.fulfilled, (state, action) => {
            state.loader = 'success';
            state.cart = []
            localStorage.removeItem('items')
        })
        
    }
});

export const {} = checkoutSlice.actions;
export default checkoutSlice.reducer;
